import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import '../../../assets/css/State/AddState.css'; // Custom styles
const API_BASE_URL = process.env.REACT_APP_API_URL;
const AddState = () => {
  const [form, setForm] = useState({
    name: '',
    code: '',
    country: '',
    remarks: '',
    status: true,
  });

  const [countries, setCountries] = useState([]);
  const { id } = useParams(); // For edit mode
  const navigate = useNavigate();
  const isEditMode = Boolean(id);

  // Fetch countries
  useEffect(() => {
    axios.get(`${API_BASE_URL}/api/countries`)
      .then((res) => setCountries(res.data))
      .catch((err) => console.error("Failed to fetch countries:", err));
  }, []);

  // Fetch state if in edit mode
  useEffect(() => {
    if (isEditMode) {
      axios.get(`${API_BASE_URL}/api/states`)
        .then((res) => {
          const stateToEdit = res.data.find((s) => s._id === id);
          if (stateToEdit) {
            setForm({
              name: stateToEdit.name,
              code: stateToEdit.code,
              country: stateToEdit.country?._id || '',
              remarks: stateToEdit.remarks || '',
              status: stateToEdit.status,
            });
          }
        })
        .catch((err) => console.error("Failed to load state:", err));
    }
  }, [id, isEditMode]); // ✅ Fix: Added isEditMode to dependency array

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm({
      ...form,
      [name]: type === 'checkbox' ? checked : value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (isEditMode) {
        await axios.put(`${API_BASE_URL}/api/states/${id}`, form);
      } else {
        await axios.post(`${API_BASE_URL}/api/states`, form);
      }
      navigate('/state');
    } catch (err) {
      console.error("Error saving state:", err);
    }
  };

  return (
    <div className="add-state-page bg-light min-vh-100 p-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4 className="page-title fw-bold">{isEditMode ? 'Edit State' : 'Add State'}</h4>
        <button className="btn custom-back-button" onClick={() => navigate('/state')}>
          <i className="bi bi-arrow-left me-1"></i> Back to State
        </button>
      </div>

      <div className="header-bar text-white p-2 rounded-top">
        <strong>{isEditMode ? 'Update State Details' : 'State Creation Form'}</strong>
      </div>

      <div className="card rounded-0 rounded-bottom">
        <div className="card-body">
          <h6 className="mb-3 border-bottom pb-2 fw-bold">General Details</h6>
          <form onSubmit={handleSubmit}>
            <div className="row g-3 mb-3">
              <div className="col-md-6">
                <label className="form-label">
                  Name <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="name"
                  placeholder="Enter State"
                  value={form.name}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="col-md-6">
                <label className="form-label">
                  Code <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="code"
                  placeholder="Enter Code"
                  value={form.code}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="col-md-6">
                <label className="form-label">
                  Country <span className="text-danger">*</span>
                </label>
                <select
                  className="form-select"
                  name="country"
                  value={form.country}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select Country</option>
                  {countries.map((country) => (
                    <option key={country._id} value={country._id}>
                      {country.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="col-md-6">
                <label className="form-label">Remarks</label>
                <input
                  type="text"
                  className="form-control"
                  name="remarks"
                  placeholder="Enter Remarks"
                  value={form.remarks}
                  onChange={handleChange}
                />
              </div>

              <div className="col-12">
                <label className="form-label me-3">Status</label>
                <div className="form-check form-switch d-inline-block">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    name="status"
                    checked={form.status}
                    onChange={handleChange}
                    id="statusSwitch"
                  />
                  <label className="form-check-label" htmlFor="statusSwitch">
                    {form.status ? 'Active' : 'Inactive'}
                  </label>
                </div>
              </div>
            </div>

            <div className="text-end mt-4">
              <button
                type="button"
                className="btn btn-outline-danger me-2"
                onClick={() => navigate('/state')}
              >
                Cancel
              </button>
              <button type="submit" className="btn btn-success">
                {isEditMode ? 'Update' : 'Save'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddState;
